/**
 * This file holds functions that performs actual state modifications
 * Please refer to https://vuex.vuejs.org/guide/mutations.html for more information
 * Also mutations MUST BE SYNCHRONOUS https://vuex.vuejs.org/guide/mutations.html#mutations-must-be-synchronous
 */
import * as types from "./types";

const mutations = {
  [types.SET_ASSETS_3D](state, payload) {
    const componentName = state.tempData.features[state.tempData.activeUGCIndex].activeUGCComponent;
    state.tempData.features[state.tempData.activeUGCIndex].responses.assets3d[componentName] = payload;
  },
  [types.SET_UGC_VIEWS](state) {
    const ugcComponents = this.getters["ugc/getUGCEnabledComponents"];
    const ugcEnabledComponents = ugcComponents.length;
    if (ugcEnabledComponents > 1) {
      // this array should come from the pdm
      state.tempData.features[state.tempData.activeUGCIndex].ugcViews = [
        "ugc-design-view",
        "ugc-almost-done",
        "ugc-confirm-design",
        "ugc-confirm-design-step"
      ];
    } else {
      state.tempData.features[state.tempData.activeUGCIndex].ugcViews = ["ugc-design-view", "ugc-confirm-design", "ugc-confirm-design-step"];
    }
  },
  /**
   * This mutations change the activUGCView rely on ugcFlowViews position
   */
  [types.CHANGE_UGC_VIEW](state) {
    const currentUgcView = this.getters["ugc/stateManager/getCurrentUgcView"];
    state.tempData.features[state.tempData.activeUGCIndex].activeUGCView = state.tempData.features[state.tempData.activeUGCIndex].ugcFlowViews[currentUgcView];
    this.commit("ugc/tempData/DELETE_TEMP_COMPONENT_SWATCH");
  },
  [types.SET_CURRENT_FEATURE_UGC_VIEW](state, payload) {
    state.tempData.features[state.tempData.activeUGCIndex].activeUGCView = payload;
    this.commit("ugc/tempData/DELETE_TEMP_COMPONENT_SWATCH");
  },

  [types.NEXT_UGC_VIEW]() {
    this.commit("ugc/tempData/CHANGE_UGC_ACTIVE_COMPONENT", true);
    this.commit("ugc/CHANGE_UGC_VIEW", true);
  },
  [types.LOAD_VIEW](state, view) {
    state.tempData.features[state.tempData.activeUGCIndex].activeUGCView = view;
  },
  [types.SAVE_MATERIAL](state, { componentName, material }) {
    state.savedUGCMesh = {
      ...state.savedUGCMesh,
      [componentName]: material
    };
  },
  [types.IS_GCC](state) {
    state.gcc_flow = true;
  },
  [types.SAVE_TONAL_STITCH](state, { componentName, tonalStitch }) {
    state.tonalStitch[componentName] = tonalStitch;
  },
  [types.LOADING_UGC_FROM_ENTRYPOINT](state, payload) {
    state.isUGCLoadingFromEntrypoint = payload;
  },
  [types.SET_UGC_BLOCKED_PALETTES](state, { component, palette }) {
    state.ugcBlockedPalettes = {
      ...state.ugcBlockedPalettes,
      [component]: palette
    };
  }
};

export default mutations;
